// extracted by mini-css-extract-plugin
export default {"main":"ReactSelect_main__vNZBQ"};